export default __webpack_public_path__ + "static/media/Illustrazione rete DT Texture.98035499.png";